import React, { useMemo } from 'react';
import { Box } from '@mui/joy';
import { KPI, Scorecard } from 'src/mtska-frontend-app-component';
import List from './List';

const Default = () => {
    const date = new Date();
    const formattedDateToday = date.toISOString().split('T')[0];
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const formattedDateStartOfMonth = `${startOfMonth.getFullYear()}/${String(startOfMonth.getMonth() + 1).padStart(2, '0')}/${String(startOfMonth.getDate()).padStart(2, '0')}`;
    
    return <>
        <Box className="mtska-chart-wrapper">
            <KPI
                title="Budget"
                icon="faCalendar"
                dataProviderName={'statistics/item/count/opportunities/lead'}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': formattedDateToday
                    }]
                }}
            />
            <KPI
                title={"Costs"}
                icon="faUpload"
                dataProviderName={'statistics/currentmonth/count/opportunities/lead'}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': formattedDateToday
                    }]
                }}
            />
            <KPI
                title={"Revenues"}
                icon="faDownload"
                dataProviderName={'statistics/currentday/count/opportunities/lead'}
                filters={{
                    'items': [{
                        'field': 'registered_at',
                        'operator': 'afterOrEqual',
                        'value': formattedDateToday
                    }]
                }}
            />

        </Box>
        <List />
    </>

}

export default Default;


